module.exports = function(h, row) {
    if (row.apply_actions == null) {
        return <i>No products assigned</i>;
    }

    let excludeProduct = JSON.parse(row.apply_actions).exclude_product;

    return <i>Assigned to {excludeProduct.length} products</i>;
};



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/setting/discount/colums/exclude_products.jsx